import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store'; // Adjust the path as needed

export interface WorkspaceFilterStateType {
    typeSlug: string | null;
}

const initialState: WorkspaceFilterStateType = {
    typeSlug: '',
};

export const workspaceFilterSlice = createSlice({
    name: 'workspaceFilter',
    initialState,
    reducers: {
        setTypeSlug: (state, action: PayloadAction<string | null>) => {
            state.typeSlug = action.payload;
        },
        setAllWorkspaceFilters: (state, action: PayloadAction<WorkspaceFilterStateType>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setTypeSlug, setAllWorkspaceFilters } = workspaceFilterSlice.actions;

export default workspaceFilterSlice.reducer;

// Selectors
export const workspaceFilterSelector = (state: RootState) => state.workspaceFilter;

export const typeSlugSelector = createSelector(
    [workspaceFilterSelector],
    (filter) => filter.typeSlug
);

export const workspaceSelector = createSelector(
    [workspaceFilterSelector],
    (filter) => filter
);
